import useDemandStudioSearchableTextarea from "../../hooks/useDemandStudioSearchableTextarea";
import { useDemandStudioContext } from "../../contexts/DemandStudioContext";
import { textareaFieldStyleClasses } from "../common/formInputClasses";

const wrapClasses = "relative";

const highlightClasses =
  "absolute inset-0 pointer-events-none text-content " +
  "whitespace-pre-wrap break-words overflow-hidden";

const textareaInputClasses =
  "relative bg-transparent! text-transparent! caret-content " +
  "[text-shadow:0_0_0_var(--color-content)] " +
  "placeholder:text-subtle placeholder:[text-shadow:none] " +
  "overflow-hidden resize-none";

const markBase = "bg-warning-light text-content p-0";
const markActive = "bg-primary-tint";

const DemandStudioSearchableTextarea = ({
  name,
  value,
  onChange,
  onFocus,
  onBlur,
  placeholder,
  className,
  minHeight = "5rem",
  activeMatchStartIndex = -1,
}) => {
  const { searchTerm } = useDemandStudioContext();

  const {
    segments,
    textareaRef,
    highlightRef,
    activeMarkRef,
    handleChange,
    syncHighlightScroll,
  } = useDemandStudioSearchableTextarea({
    value,
    onChange,
    minHeight,
    searchTerm,
    activeMatchStartIndex,
  });

  return (
    <div className={wrapClasses}>
      <div ref={highlightRef} className={`${highlightClasses} ${className || ""}`} aria-hidden>
        {segments.map((segment, index) =>
          segment.isMatch ? (
            <mark
              key={`segment-${index}`}
              className={`${markBase} ${segment.isActive ? markActive : ""}`}
              ref={segment.isActive ? activeMarkRef : null}
            >
              {segment.text}
            </mark>
          ) : (
            <span key={`segment-${index}`}>{segment.text}</span>
          )
        )}
      </div>
      <textarea
        ref={textareaRef}
        name={name}
        value={value || ""}
        onChange={handleChange}
        onFocus={onFocus}
        onBlur={onBlur}
        onScroll={syncHighlightScroll}
        placeholder={placeholder}
        className={`${className || textareaFieldStyleClasses} ${textareaInputClasses}`}
      />
    </div>
  );
};

export default DemandStudioSearchableTextarea;
